export default "__VITE_ASSET__5692a540__"